import {
  ACTION_PUT_FLIGT_TOUR_CODES,
  ACTION_PUT_FLIGT_TOUR_CODES_SUCCESS,
  ACTION_PUT_FLIGT_TOUR_CODES_FAILURE,
  API_CALL,
} from '../../../configs/ActionTypes';
import { Dispatch } from 'redux';
import { enqueueSnackbarHandler } from '../../Status';
import * as _ from 'lodash-es';

export type datatype = {
  organizationId?: string;
  value?: any;
};

export function putFlightTourCodes(data: datatype) {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch(requestStarted());
    //Dispatch the api call request.
    dispatch({
      type: API_CALL,
      payload: {
        call: 'organizations/flighttourcodes',
        method: 'PUT',
        data: JSON.stringify(data),
        success: (response: any) => {
          if (response.type === 'error') {
            dispatch(requestFailed(response));
            _.get(response.payload, 'payload.userPermissionError', false)
              ? enqueueSnackbarHandler(
                  dispatch,
                  response.payload.payload,
                  'error',
                )
              : enqueueSnackbarHandler(
                  dispatch,
                  { updateFlightTourCodeFailed: true },
                  'error',
                );
          } else {
            enqueueSnackbarHandler(
              dispatch,
              { updateFlightTourCode: true },
              'success',
            );
            dispatch(requestSuccess(response));
          }
        },
        fail: (error: any) => {
          dispatch(requestFailed(error));
          _.get(error.payload, 'userPermissionError', false)
            ? enqueueSnackbarHandler(dispatch, error.payload, 'error')
            : enqueueSnackbarHandler(
                dispatch,
                { updateFlightTourCodeFailed: true },
                'error',
              );
        },
      },
    });
    return null;
  };
}

export function requestStarted() {
  return {
    type: ACTION_PUT_FLIGT_TOUR_CODES,
    payload: null,
  };
}

export function requestSuccess(responseJSON: object) {
  return {
    type: ACTION_PUT_FLIGT_TOUR_CODES_SUCCESS,
    payload: responseJSON,
  };
}

export function requestFailed(responseJSON: object) {
  return {
    type: ACTION_PUT_FLIGT_TOUR_CODES_FAILURE,
    payload: responseJSON,
  };
}
